<template>
  <div class="tab-pane" id="tab_1_5">
    <div class="portlet light">
      <div class="row">
        <div class="col-xs-12 col-md-6 col-md-offset-3">
          <div style="border: 1px solid #C2CAD8; margin-right: 1em; padding: 1em; margin-bottom: 1em;">
            <div class="text-center ss-titre">
              <strong>Ajout de partenaires :</strong>&nbsp;-&nbsp;<em class="text-center" style="font-size: 11px;">jpg ou png acceptés uniquement</em>
              <v-input type="text" name="website" title="Lien du site du partenaire" v-model="partner.website"></v-input>
            </div>
             <v-image-upload
                :key="imageKey"
                :oldImage="selectedImage"
                name="partner_image"
                :display="false"
                @image="addNewImage"
                :ratio="1">
            </v-image-upload>
            <button v-show="showBtn" class="btn green btn-block mt-1" @click="send">Ajouter le partenaire</button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="ss-titre">
          <span class="font-red-sunglo uppercase bold">Partenaires ajoutés :</span>
        </div>
        <div class="portlet-body">
          <div class="portlet light">
            <!-- Image Cards -->
            <div class="mt-element-card mt-element-overlay" v-for="(partner, index) in newPartners">
              <div class="col-lg-2 col-md-6 col-sm-6 col-xs-12">
                <div class="mt-card-item boxShadowGreen">
                  <div class="mt-card-avatar mt-overlay-1" style="background-color: #C7C89E;">
                    <img v-if="partner.images[0]" :src="`/${partner.images[0].optimized}`" class="containCardImg">
                    <div class="mt-overlay">
                      <button class="btn btn-danger btn-outline btnCard pull-right btnRadius" @click="deletePartner(partner, index)">
                          <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          <!-- End Image Cards -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'OfficePartenaireForm',

  props: {
    partners: {
      type: Array,
      default : () => {
        return []
      }
    },
    office: {
      type: Object
    }
  },
  data () {
    return {
      selectedImage: {},
      newImage: new vImageHelper(),
      newPartners: this.partners,
      imageKey: 0,
      partner: {},
      showBtn: false,
    }
  },
  methods: {
    addNewImage(event) {
        this.newImage.add(event)
        this.showBtn = true
    },
    async deletePartner(partner, index) {
      this.$delete(this.newPartners, index)

      await axios.delete(`/partner/${partner.id}`)

      this.$snotify.success("Le partenaire a bien été supprimée")
    },
    async send() {
      const response = await axios.post('/partner', this.partner)

      this.partner = response.data['partner']

      this.newImage.send(`/partner/${this.partner.id}/image`, () => {
        this.partner.images = []
        this.partner.images.push(this.newImage.response.image)
        this.partners.push(this.partner)
        this.partner = {}
        this.selectedImage = {}
        this.imageKey += 1
      })

      this.$snotify.success("Le partenaire a bien été ajouté")
      this.showBtn = false

    }
  }
};
</script>

<style lang="css" scoped>
.mt-1{
  margin-top: .4rem
}
</style>
